import { useState } from "react";
import { X } from "lucide-react";
import { PageShell } from "@/components/site/PageShell";
import { BRAND_PHOTOS } from "@/lib/constants";

const ITEMS = BRAND_PHOTOS.map((src, i) => ({ id: i + 1, src }));

export default function Gallery() {
  const [open, setOpen] = useState(null);
  return (
    <PageShell testId="gallery-page" overline="Gallery" title="From the workshop floor." image={BRAND_PHOTOS[2]}
      intro="Photography from the Accelary Motors website archive. Project details will be added as the workshop confirms each vehicle.">
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [&>*]:mb-4">
        {ITEMS.map((it) => (
          <button key={it.id} onClick={() => setOpen(it)} data-testid={`gallery-item-${it.id}`}
            className="group block w-full overflow-hidden rounded-2xl bg-white">
            <img src={it.src} alt={`Accelary workshop project ${it.id}`} loading="lazy"
              className="w-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
          </button>
        ))}
      </div>
      {open && (
        <div className="fixed inset-0 z-50 bg-[#070B19]/90 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(null)} data-testid="gallery-lightbox">
          <button className="absolute top-5 right-5 text-white" data-testid="gallery-lightbox-close" aria-label="Close"><X className="h-7 w-7" /></button>
          <figure className="max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <img src={open.src} alt="" className="max-h-[80vh] rounded-xl" />
            <figcaption className="mt-3 text-sm text-white/70">Workshop archive photo {open.id} — project notes pending owner confirmation.</figcaption>
          </figure>
        </div>
      )}
    </PageShell>
  );
}
